// extracted by mini-css-extract-plugin
export default {"calendar":"calendar_calendar__oQwg+","year":"calendar_year__Bnuez"};